import React, { useState, useContext } from 'react';
import CreatableSelect from 'react-select/creatable';
import { components } from 'react-select'
import { SvgChevronDown } from '../assets/icons';
import Loading from './Loading';
import MixpanelContext from 'react-mixpanel';

const cannedOptions = [
  { value: 'Home Office', label: 'Home Office' },
  { value: 'Dining Room ', label: 'Dining Room ' },
  { value: 'Bedroom', label: 'Bedroom' },
  { value: 'Dog Walks ', label: 'Dog Walks ' },
  { value: 'Home Schooling', label: 'Home Schooling' },
  { value: 'Coffee Breaks', label: 'Coffee Breaks' },
  { value: 'Baby Feedings', label: 'Baby Feedings' },
  { value: 'Meals & Meal Planning', label: 'Meals & Meal Planning' },
  { value: 'pick-ups/drop-offs', label: 'Pick Ups/Drop Offs' },
  { value: 'Exercise Breaks', label: 'Exercise Breaks' },
  { value: 'Down Time ', label: 'Down Time ' },
  { value: 'Connect with Friends & Family', label: 'Connect with Friends & Family' },
];

const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <div className="embeddedButton">
          <SvgChevronDown style={{ position: 'relative', left: 9, top: 2 }} />
        </div>
      </components.DropdownIndicator>
    )
  );
};

function AddCalendar({ onAddCalendar, hasSchedules}) {
  const [expanded, setExpanded] = useState(!hasSchedules);
  const [submitting, setSubmitting] = useState(false);
  const mixpanel = useContext(MixpanelContext);

  const handleSubmit = async ({ value }) => {
    setSubmitting(true)
    try {
      if(onAddCalendar) await onAddCalendar(value)
      setExpanded(false)
      mixpanel.track('WFH_Add_Schedule_Complete', { name: value })
    } catch(e) {
      console.error(e)
    } finally {
      setSubmitting(false)
    }
  }

  const toggleSelect = (e) => {
    if(!expanded) {
      mixpanel.track('WFH_Add_Schedule_Tapped')
    }
    setExpanded(!expanded);
    e.target.blur() ;
  }

  return (
    <>
      { hasSchedules && <button
        type="button"
        className="btn btn-primary"
        style={{margin: 8, paddingLeft: 45, paddingRight: 45, marginLeft: 'auto', marginRight: 'auto', display: 'block'}}
        onClick={toggleSelect}>
          { expanded ? "CLOSE" : "ADD A SCHEDULE" }
      </button>}
      { !hasSchedules && <>
        <h3 style={{fontWeight: 'bold', textAlign: 'center'}}>ADD YOUR FIRST SCHEDULE</h3>
        <p>Schedules are time-based organizers that allow you to book quiet spaces in your home to work or block time for responsibilities like walking the dog.</p>
        <p>All schedules are shared with the members of your household to keep you all on the same page.</p>
      </>}
      { expanded && <>
        { submitting && <Loading /> }
        { !submitting && <div>
          <CreatableSelect
            options={cannedOptions}
            defaultMenuIsOpen={true}
            formatCreateLabel={(inputValue) => {
              return `Add Schedule '${inputValue}'`
            }}
            classNamePrefix="addCalendar"
            onChange={handleSubmit}
            placeholder="Choose one or type your own..."
            components={{ DropdownIndicator, IndicatorSeparator: null }}
          />
        </div>}
      </>}
    </>
  );
}

export default AddCalendar;
